import {isDonationTicketDefinition, isFreeTicketDefinition, isTicketed} from '@wix/wix-events-commons-statics'
import {State} from '../types/state'
import {getReservations} from './checkout'
import {getEvent} from './event'
import {getInvoice} from './placed-order'
import {getSortedSelectedTickets} from './selected-tickets'
import {getTickets, isFixedPriceTicketSelected} from './tickets'

export const isCouponsAccepted = (state: State) => state.checkoutOptions.options.acceptCoupons

export const isGiftCardsAccepted = (state: State) => state.checkoutOptions.options.acceptGiftCards

export const isUpgradeNeededForCheckout = (state: State) => {
  const {
    grandTotal: {amount},
  } = getInvoice(state)

  return !state.checkoutOptions.options.premiumServices && Number(amount) > 0
}

export const isFixedPriceTicketReserved = (state: State) => {
  const event = getEvent(state)
  const reservations = getReservations(state)
  const tickets = getTickets(state)

  return (
    isTicketed(event) &&
    reservations.some(({ticket: {id}}) => {
      const ticketDefinition = tickets.find(ticket => ticket.id === id)

      return !isFreeTicketDefinition(ticketDefinition) && !isDonationTicketDefinition(ticketDefinition)
    })
  )
}

export const isFixedPriceTicketsSelected = (state: State) => {
  const event = getEvent(state)
  const tickets = getTickets(state)
  const sortedSelectedTickets = getSortedSelectedTickets(state)

  return isTicketed(event) && isFixedPriceTicketSelected(tickets, sortedSelectedTickets)
}

export const isCouponInputVisible = (state: State, fixDetailsPageNavigationEnabled: boolean) =>
  (fixDetailsPageNavigationEnabled ? isFixedPriceTicketReserved(state) : isFixedPriceTicketsSelected(state)) &&
  isCouponsAccepted(state)

export const isGiftCardInputVisible = (state: State, fixDetailsPageNavigationEnabled: boolean) =>
  (fixDetailsPageNavigationEnabled ? isFixedPriceTicketReserved(state) : isFixedPriceTicketsSelected(state)) &&
  isGiftCardsAccepted(state)
